import React from "react";
import ServiceWorld from "@/src/components/Serviceworld/ServiceWorld";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

const ServiceWorldPage = () => {
  const title = "Servicewelt | Legalbird";
  gaSet({ title: title });

  return (
    <LayoutProtectedRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ServiceWorld />
    </LayoutProtectedRoutes>
  );
};

export default ServiceWorldPage;
